interface BuyAgainCtaProps {
  hasStock: boolean | undefined | null;
  hasOtherVintageStock: boolean | undefined | null;
  isAbbreviated?: boolean;
  t: Function;
  isTopupV2Enabled: boolean;
}

const getBuyAgainCtaLabel = ({
  hasStock,
  hasOtherVintageStock,
  isAbbreviated,
  t,
  isTopupV2Enabled,
}: BuyAgainCtaProps) => {
  let label;
  if (!isTopupV2Enabled) {
    label = hasStock ? t("common:topUp") : t("common:soldOut");
  } else if (hasStock) {
    label = t("common:buyAgain");
  } else if (hasOtherVintageStock) {
    label = isAbbreviated ? t("common:newVintageIn") : t("common:newVintageAvailable");
  } else {
    label = t("common:soldOut");
  }
  return label;
};

export default getBuyAgainCtaLabel;
